export default __webpack_public_path__ + "static/media/icon-dollar.c1bac52e.svg";